/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetAccountDataCheckSampleRequest} from '@cash-web/protos/squareup/cash/janus/api/AccountHolder.pb'
import {GetAccountDataCheckSampleResponse} from '@cash-web/protos/squareup/cash/janus/api/AccountHolder.pb'


export const getAccountDataCheckSample = (request:GetAccountDataCheckSampleRequest, options?: CashRequestOptions) => post<GetAccountDataCheckSampleRequest, GetAccountDataCheckSampleResponse>("/2.0/cash/get-account-data-check-sample", request, {...options, rejectOnError: true })